// adminApi.js - Mock API สำหรับฟังก์ชันแอดมิน
import axios from "../lib/axios";

// ฟังก์ชันตรวจสอบและแก้ไข ID
const normalizeMovieId = (id) => {
  if (!id || id === "undefined" || id === undefined) {
    return null;
  }
  return id.toString();
};

// ดึงหนังทั้งหมด (รวมที่ซ่อน) สำหรับแอดมิน
export const getAllMoviesForAdmin = async () => {
  try {
    const response = await axios.get("/movies/admin/all");
    return response.data;
  } catch (error) {
    console.error("Error fetching all movies for admin:", error);

    // ถ้า API ยังไม่พร้อม ใช้ข้อมูล mock
    return [
      {
        _id: "60f7b1b3b3f4b3001f7e8a01",
        id: "60f7b1b3b3f4b3001f7e8a01",
        title: "Introduction to Computer Science",
        description: "บทเรียนพื้นฐานวิทยาการคอมพิวเตอร์",
        poster:
          "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=300&h=200&fit=crop&crop=center",
        thumbnail:
          "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=300&h=200&fit=crop&crop=center",
        duration: "45 นาที",
        category: "Computer Science",
        isHidden: false,
        createdAt: "2024-01-15",
        updatedAt: "2024-01-15",
      },
      {
        _id: "60f7b1b3b3f4b3001f7e8a02",
        id: "60f7b1b3b3f4b3001f7e8a02",
        title: "Data Structures and Algorithms",
        description: "โครงสร้างข้อมูลและอัลกอริทึม",
        poster:
          "https://images.unsplash.com/photo-1509475826633-fed577a2c71b?w=300&h=200&fit=crop&crop=center",
        thumbnail:
          "https://images.unsplash.com/photo-1509475826633-fed577a2c71b?w=300&h=200&fit=crop&crop=center",
        duration: "60 นาที",
        category: "Computer Science",
        isHidden: false,
        createdAt: "2024-01-16",
        updatedAt: "2024-01-16",
      },
      {
        _id: "60f7b1b3b3f4b3001f7e8a03",
        id: "60f7b1b3b3f4b3001f7e8a03",
        title: "Web Development Fundamentals",
        description: "พื้นฐานการพัฒนาเว็บไซต์",
        poster:
          "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=300&h=200&fit=crop&crop=center",
        thumbnail:
          "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=300&h=200&fit=crop&crop=center",
        duration: "90 นาที",
        category: "Web Development",
        isHidden: true,
        createdAt: "2024-01-17",
        updatedAt: "2024-01-20",
      },
      {
        _id: "60f7b1b3b3f4b3001f7e8a04",
        id: "60f7b1b3b3f4b3001f7e8a04",
        title: "Database Design",
        description: "การออกแบบฐานข้อมูล",
        poster:
          "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=300&h=200&fit=crop&crop=center",
        thumbnail:
          "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=300&h=200&fit=crop&crop=center",
        duration: "75 นาที",
        category: "Database",
        isHidden: false,
        createdAt: "2024-01-18",
        updatedAt: "2024-01-18",
      },
      {
        _id: "60f7b1b3b3f4b3001f7e8a05",
        id: "60f7b1b3b3f4b3001f7e8a05",
        title: "Machine Learning Basics",
        description: "พื้นฐานการเรียนรู้ของเครื่อง",
        poster:
          "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=300&h=200&fit=crop&crop=center",
        thumbnail:
          "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=300&h=200&fit=crop&crop=center",
        duration: "120 นาที",
        category: "AI/ML",
        isHidden: true,
        createdAt: "2024-01-19",
        updatedAt: "2024-01-21",
      },
    ];
  }
};

// ดึงหนังที่ซ่อนอยู่เท่านั้น
export const getHiddenMovies = async () => {
  try {
    const response = await axios.get("/movies/admin/hidden");
    return response.data;
  } catch (error) {
    console.error("Error fetching hidden movies:", error);

    // fallback ไปใช้ getAllMoviesForAdmin แล้วกรอง
    const allMovies = await getAllMoviesForAdmin();
    return allMovies.filter((movie) => movie.isHidden);
  }
};

// ซ่อนหนัง
export const hideMovie = async (movieId) => {
  const normalizedId = normalizeMovieId(movieId);
  if (!normalizedId) {
    throw new Error("Invalid movie ID provided");
  }

  try {
    const response = await axios.patch(`/movies/${normalizedId}/hide`);
    return response.data;
  } catch (error) {
    console.error(`Error hiding movie ${normalizedId}:`, error);

    // Mock response
    return {
      success: true,
      message: `Movie ${normalizedId} hidden successfully`,
      movieId: normalizedId,
      isHidden: true,
    };
  }
};

// แสดงหนัง
export const showMovie = async (movieId) => {
  const normalizedId = normalizeMovieId(movieId);
  if (!normalizedId) {
    throw new Error("Invalid movie ID provided");
  }

  try {
    const response = await axios.patch(`/movies/${normalizedId}/show`);
    return response.data;
  } catch (error) {
    console.error(`Error showing movie ${normalizedId}:`, error);

    // Mock response
    return {
      success: true,
      message: `Movie ${normalizedId} shown successfully`,
      movieId: normalizedId,
      isHidden: false,
    };
  }
};

// อัพเดตสถานะการแสดงผลหนัง
export const updateMovieVisibility = async (movieId, isHidden) => {
  if (isHidden) {
    return await hideMovie(movieId);
  } else {
    return await showMovie(movieId);
  }
};

// ตรวจสอบสิทธิ์แอดมิน
export const checkAdminPermission = (username) => {
  return username === "smoker8888";
};

// สถิติแอดมิน
export const getAdminStats = async () => {
  try {
    const response = await axios.get("/admin/stats");
    return response.data;
  } catch (error) {
    console.error("Error fetching admin stats:", error);

    // Mock stats
    const allMovies = await getAllMoviesForAdmin();
    const visibleMovies = allMovies.filter((movie) => !movie.isHidden);
    const hiddenMovies = allMovies.filter((movie) => movie.isHidden);

    return {
      totalMovies: allMovies.length,
      visibleMovies: visibleMovies.length,
      hiddenMovies: hiddenMovies.length,
      categories: [...new Set(allMovies.map((movie) => movie.category))].length,
      recentlyUpdated: allMovies.filter((movie) => {
        const updatedDate = new Date(movie.updatedAt);
        const weekAgo = new Date();
        weekAgo.setDate(weekAgo.getDate() - 7);
        return updatedDate > weekAgo;
      }).length,
    };
  }
};

const adminApi = {
  getAllMoviesForAdmin,
  getHiddenMovies,
  hideMovie,
  showMovie,
  updateMovieVisibility,
  checkAdminPermission,
  getAdminStats,
};

export default adminApi;
